import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAdminBomList = createAsyncThunk(
    "/admin/get-admin-bom-list",
    async (payload = {}) => {
        try {
            const myurl = `${V_URL}/believe/get-boms`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to fetch BOMs");
            }
        } catch (error) {
            console.error("Error in getAdminBomList:", error);
            toast.error(error.response?.data?.message || "Error fetching Bill of Materials");
            throw error;
        }
    }
);

const getAdminBomListSlice = createSlice({
    name: "getAdminBomList",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAdminBomList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdminBomList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAdminBomList.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getAdminBomListSlice.reducer;
